import type { ReactNode } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import type { DialogProps } from '@mui/material/Dialog';
import { dialogSlotProps } from './dialogSlotProps';

type BaseDialogProps = {
  open: boolean;
  title: ReactNode;
  onClose: () => void;
  children: ReactNode;
  actions?: ReactNode;
  maxWidth?: DialogProps['maxWidth'];
};

export const BaseDialog = ({
  open,
  title,
  onClose,
  children,
  actions,
  maxWidth = 'xs',
}: BaseDialogProps) => (
  <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth slotProps={dialogSlotProps}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent sx={{ overflow: 'visible', pt: 1.25 }}>{children}</DialogContent>
    {actions && <DialogActions>{actions}</DialogActions>}
  </Dialog>
);
